import {
  CreateTransactionFn,
  PairingRequestFn,
  PairingRequestResponse,
  PollForOutcomeFn,
  TransactionMode,
} from "./types";
import {
  PAIRING_ENDPOINT,
  BASE_URL_DEV,
  BASE_URL_PROD,
  TRANSACTION_ENDPOINT,
} from "./constants";
import axios from "axios";

export const pollForOutcome: PollForOutcomeFn = async (pollingUrl: string) => {
  try {
    const response = await axios.get(pollingUrl);
    return response.data;
  } catch (error) {
    // if axios error, attempt to extract the error message
    if (axios.isAxiosError(error) && error.response?.data?.error) {
      return { error: error.response.data.error };
    }
    throw new Error(
      "Failed to poll for transaction outcome. Please try again later."
    );
  }
};

export const sendPairingRequest: PairingRequestFn = async (
  pairingCode,
  options
): Promise<PairingRequestResponse> => {
  const { input } = options;

  // Replace the [pairingId] placeholder with the actual code
  const endpoint = PAIRING_ENDPOINT.replace("[pairingId]", pairingCode);

  const url = `${
    process.env.NODE_ENV === "production" ? BASE_URL_PROD : BASE_URL_DEV
  }${endpoint}`;

  // input must be application/x-www-form-urlencoded
  const formData = new URLSearchParams();
  for (const [key, value] of Object.entries(input)) {
    if (value !== undefined && value !== null) {
      formData.append(key, value as string);
    }
  }
  try {
    const response = await axios.put<PairingRequestResponse>(url, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    // if axios error, attempt to extract the error message
    if (axios.isAxiosError(error) && error.response?.data?.error) {
      return error.response.data;
    }
    throw new Error("Failed to send pairing request. Please try again later.");
  }
};

export const createTransaction: CreateTransactionFn = async (
  amountInCents,
  transactionType,
  metadata
) => {
  const url = `${
    process.env.NODE_ENV === "production" ? BASE_URL_PROD : BASE_URL_DEV
  }${TRANSACTION_ENDPOINT}`;

  const parameters = {
    POSRegisterID: metadata.registerId,
    POSVendorName: metadata.posVendorName,
    POSBusinessName: metadata.posBusinessName,
    TransactionMode: TransactionMode.Async,
    TransactionType: transactionType,
    AmountTotal: amountInCents,
  };

  // must be application/x-www-form-urlencoded
  const formData = new URLSearchParams();
  for (const [key, value] of Object.entries(parameters)) {
    if (value !== undefined && value !== null) {
      formData.append(key, value.toString());
    }
  }
  try {
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    // if axios error, attempt to extract the error message
    if (axios.isAxiosError(error) && error.response?.data?.error) {
      return { error: error.response.data.error };
    }
    throw new Error("Failed to create transaction. Please try again later.");
  }
};
